// extracted by mini-css-extract-plugin
module.exports = {"horizontalCarouselLeftArrow":"HorizontalCarouselLeftArrow_horizontalCarouselLeftArrow__A54WN","float":"HorizontalCarouselLeftArrow_float__wfhbQ"};